import React from "react";
import { Ticket } from "../../../models/Ticket";
import "./style.scss";
import { HiQrcode } from "react-icons/hi";
import { BiChevronRight } from "react-icons/bi";
import format from "date-fns/format";
import { useTranslation } from "react-i18next";

interface IProps {
  ticket: Ticket;
}
const SelectPassBar: React.FC<IProps> = ({ ticket }: IProps) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="exercise-plan__header">
        <div className="flex-start-center">
          <HiQrcode className="icon-bar" />
          <b>{ticket.name}</b>
        </div>
        <div className="flex-start-center">
          <BiChevronRight className="icon-bar icon-bar-next" />
          
          {ticket.entrances - ticket.exercises.length > 200 ? (
              <b>Zapisy bez limitu</b>

            ) : (

              
          <b>
          {t("pozostalo_zapisow")}: {ticket.entrances - ticket.exercises.length}
        </b>
            )}

        </div>

        <div className="flex-start-center">
          <BiChevronRight className="icon-bar icon-bar-next" />
          <b>
            {t("wazny_do")}: {format(ticket.validto, "dd.MM.yyyy")}r.
          </b>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SelectPassBar;
